var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVideoSkip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.75C5.44365 3.75 1.75 7.44365 1.75 12C1.75 16.5563 5.44365 20.25 10 20.25C14.5563 20.25 18.25 16.5563 18.25 12C18.25 11.5858 18.5858 11.25 19 11.25C19.4142 11.25 19.75 11.5858 19.75 12C19.75 17.3848 15.3848 21.75 10 21.75C4.61522 21.75 0.25 17.3848 0.25 12C0.25 6.61522 4.61522 2.25 10 2.25H16.875C17.2892 2.25 17.625 2.58579 17.625 3C17.625 3.41421 17.2892 3.75 16.875 3.75H10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4697 0.46967C15.7626 0.176777 16.2374 0.176777 16.5303 0.46967L18.5303 2.46967C18.8232 2.76256 18.8232 3.23744 18.5303 3.53033L16.5303 5.53033C16.2374 5.82322 15.7626 5.82322 15.4697 5.53033C15.1768 5.23744 15.1768 4.76256 15.4697 4.46967L16.9393 3L15.4697 1.53033C15.1768 1.23744 15.1768 0.762563 15.4697 0.46967Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2432 15.4668C10.4756 15.4668 9.40137 14.1484 9.40137 11.834C9.40137 9.51953 10.4756 8.20117 12.2432 8.20117C14.0107 8.20117 15.085 9.5293 15.085 11.834C15.085 14.1582 14.0107 15.4668 12.2432 15.4668ZM12.2432 14.2559C13.0635 14.2559 13.5908 13.4648 13.5811 11.834C13.5811 10.2227 13.0635 9.40234 12.2432 9.40234C11.4229 9.40234 10.9053 10.2227 10.9053 11.834C10.8955 13.4648 11.4229 14.2559 12.2432 14.2559Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98478 8.29883C7.57783 8.29883 8.05859 8.77959 8.05859 9.37264V14.6318C8.05859 15.039 7.72849 15.3691 7.32129 15.3691C6.91409 15.3691 6.58398 15.039 6.58398 14.6318V9.72565C6.58398 9.7089 6.5704 9.69531 6.55364 9.69531C6.54794 9.69531 6.54236 9.69692 6.53753 9.69994L5.76806 10.182C5.40079 10.4121 4.92383 10.1481 4.92383 9.7147C4.92383 9.52623 5.02008 9.35081 5.17905 9.24956L6.40795 8.46691C6.58032 8.35714 6.78043 8.29883 6.98478 8.29883Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoSkip);
export default __webpack_public_path__ + "static/media/icon-video-skip.5e29b1802081865ef1ac06423458dea3.svg";
export { ForwardRef as ReactComponent };